import React from "react";
import { Input as AntdInput } from "antd";
import { cva } from "class-variance-authority";

import { cn } from "utils/cn";

const SIZE_TO_ANTD = {
  sm: "small",
  md: "middle",
  lg: "large"
};

const textFieldVariants = cva(
  "!px-3 !text-sm !rounded-md placeholder:!text-xs placeholder:!text-placeholder",
  {
    variants: {
      variant: {
        outline: "!bg-white hover:!border-brand focus:!border-brand",
        filled: [
          "!bg-input !border-border",
          "hover:!bg-white hover:!border-brand",
          "focus:!bg-white focus:!border-brand"
        ].join(" ")
      },
      size: {
        sm: "!h-6 !text-xs",
        md: "!h-8",
        lg: "!h-11"
      }
    },
    defaultVariants: {
      variant: "outline",
      size: "md"
    }
  }
);

const TextField = React.forwardRef(({ variant = "outline", size = "md", className, ...props }, ref) => {
  const antdSize = SIZE_TO_ANTD[size] ?? "middle";

  return (
    <AntdInput
      ref={ref}
      size={antdSize}
      className={cn(textFieldVariants({ variant, size }), className)}
      {...props}
    />
  );
});

TextField.displayName = "TextField";

export { TextField, textFieldVariants };
export default TextField;
